export default __webpack_public_path__ + "static/media/_DSC0273.8f61ebe9.JPG";